/**
 * OTP strip policy. Gate 1/2 is not a code. Only mirror_live / ui.code paint it.
 */

export function phaseStem(detail: string | null | undefined): string {
  const phase = (detail ?? "").trim();
  return phase.endsWith(".txt") ? phase.slice(0, -4) : phase;
}

/** True when the engine is collecting the code (enter_code / retry), not ident. */
export function isCodeCollectState(state: string | null | undefined, detail?: string | null): boolean {
  if ((state ?? "").toUpperCase() === "COLLECTING") return true;
  const stem = phaseStem(detail);
  return stem === "enter_code" || stem === "retry";
}

/** Ident 1/2. Never an OTP. */
export function isGateState(state: string | null | undefined, detail?: string | null): boolean {
  if ((state ?? "").toUpperCase() === "ACCEPT_GATE") return true;
  return phaseStem(detail) === "identification";
}

export function isGateKind(kind: string | null | undefined): boolean {
  return (kind ?? "").trim().toLowerCase() === "gate";
}

/**
 * session.dtmf kinds that may paint the OTP strip.
 * `live` is mirror_live. `otp` is the code collect result. Gate is never included.
 */
export function paintDigitStrip(kind: string | null | undefined): boolean {
  const key = (kind ?? "").trim().toLowerCase();
  return key === "live" || key === "otp";
}

/**
 * Hold window: the session accepts O from send_code through send_otp.
 * Display only — O button enablement stays with server `ui.actions`.
 */
export function isHoldPhase(state: string | null | undefined, detail?: string | null): boolean {
  if ((state ?? "").toUpperCase() !== "PLAYING") return false;
  const stem = phaseStem(detail);
  return stem === "send_code" || stem === "send_otp";
}

export function dtmfKindLabel(
  state: string | null | undefined,
  detail: string | null | undefined,
  digitKind: string | null | undefined,
): string {
  if (isHoldPhase(state, detail)) return "hold";
  if (digitKind === "gate" || isGateState(state, detail)) return "gate";
  if (digitKind === "otp" || isCodeCollectState(state, detail)) return "code";
  return "—";
}
